import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { MqttProvider } from './mqtt.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <StrictMode>
    <MqttProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MqttProvider>
  </StrictMode>,
)
